export default "__VITE_ASSET__DQZ4emX$__"